import { useEffect, useState } from 'react'
import { api } from '../utils/api'
import { useAuthStore } from '../stores/authStore'

export interface RecentFile {
  id: string
  name: string
  path: string
  size: number
  mimeType: string
  uploadDate: string
  isPublic: boolean
}

// Owns the backend-sourced recent-uploads fetch + its state. The consuming
// sidebar keeps its favorites logic + presentation. Behaviour mirrors the
// previous in-component logic exactly (refetch on token/csrf/refreshKey change).
export function useRecentFiles(refreshKey: number = 0) {
  const { token, csrfToken } = useAuthStore()
  const [recent, setRecent] = useState<RecentFile[]>([])
  const [loadingRecent, setLoadingRecent] = useState(true)

  useEffect(() => {
    if (!token) return
    let cancelled = false
    const load = async () => {
      setLoadingRecent(true)
      try {
        const res = await api.getRecentFiles(8, token, csrfToken || undefined)
        if (cancelled) return
        if (res.success && res.data) setRecent(res.data.items)
      } catch { /* silent */ }
      finally { if (!cancelled) setLoadingRecent(false) }
    }
    load()
    return () => { cancelled = true }
  }, [token, csrfToken, refreshKey])

  return { recent, loadingRecent }
}
